import Service from "../../service";

const PreSchoolService = {
  //Forms
  createForm: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/form`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  updateFormTemplate: async (token, body, formId) => {
    try {
      return await Service.update({
        url: `/schools/v1/form?id=${formId}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  getTemplateFormByID: async (token, id) => {
    try {
      return await Service.get(`/schools/v1/form?id=${id}`, token);
    } catch (error) {
      throw error;
    }
  },
  deleteTemplateForm: async (token, id) => {
    try {
      return await Service.remove({ url: `/schools/v1/form?id=${id}`, token });
    } catch (error) {
      throw error;
    }
  },

  getForms: async ({ token, search, type }) => {
    try {
      return await Service.get(
        `/schools/v1/form/list?type=${type}&${
          search ? `search=${search}` : ""
        }`,
        token
      );
    } catch (error) {
      throw error;
    }
  },

  // Classes
  createClass: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/class`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  // EXPORT CLASS
  exportClass: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/class/export`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  // Send Class participant letter
  sendClassParticipantLetter: async (token, data) => {
    try {
      return await Service.post({
        url: `/schools/v1/participant/letter`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  // export Class participant
  exportClassParticipant: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/participant/export`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  createEvent: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/event`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  getClassesList: async (token, current_page, items_per_page, body = null) => {
    try {
      return await Service.post({
        url: `/schools/v1/class/list?current_page=${current_page}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  getAllClasses: async (token, body = null) => {
    try {
      return await Service.post({
        url: `/schools/v1/class/list`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  getClassById: async (token, id) => {
    try {
      return await Service.get(`/schools/v1/class?id=${id}`, token);
    } catch (error) {
      throw error;
    }
  },
  deleteClass: async (token, id) => {
    try {
      return await Service.remove({ url: `/schools/v1/class?id=${id}`, token });
    } catch (error) {
      throw error;
    }
  },

  // GET EVENT BY ID
  getEventById: async (token, id) => {
    try {
      return await Service.get(`/schools/v1/event?id=${id}&admin=true`, token);
    } catch (error) {
      throw error;
    }
  },
  // UPDATE EVENT
  updateEvent: async (token, body, id) => {
    try {
      return await Service.update({
        url: `/schools/v1/event?id=${id}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  archiveClass: async (token, body) => {
    try {
      return await Service.update({
        url: `/schools/v1/class/archive`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  getArchivedClasses: async (
    token,
    current_page,
    items_per_page,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `/schools/v1/class/archive?current_page=${current_page}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  updateClass: async (token, body, id) => {
    try {
      return await Service.update({
        url: `/schools/v1/class?id=${id}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  duplicateClass: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/class/duplicate`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  // participants
  getClassParticipants: async (
    token,
    current_page,
    items_per_page,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `/schools/v1/participant/list?current_page=${current_page}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  getParticipantById: async (token, id) => {
    try {
      return await Service.get(`/schools/v1/participant?id=${id}`, token);
    } catch (error) {
      throw error;
    }
  },
  deleteParticipantById: async (token, id) => {
    try {
      return await Service.remove({
        url: `/schools/v1/participant?id=${id}`,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  updateParticipant: async (token, body, id) => {
    try {
      return await Service.update({
        url: `/schools/v1/participant?id=${id}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  updateParticipantParentInfo: async (token, body, id) => {
    try {
      return await Service.update({
        url: `/schools/v1/participant/parent-info?id=${id}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  changeStatusParticipant: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/participant/status`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  sendPaymentLink: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/participant/payment-link`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  moveParticipant: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/participant/move`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  // get class participants accounts
  getClassParticipantsAccounts: async (token, classId, search) => {
    try {
      return await Service.get(
        `/schools/v1/participant/accounts-members?classId=${classId}${
          search ? `&search=${search}` : ""
        }`,
        token
      );
    } catch (error) {
      throw error;
    }
  },

  // get Event participants accounts
  getEventParticipantsAccounts: async (token, eventId, search) => {
    try {
      return await Service.get(
        `/schools/v1/event/participant/accounts-members?eventId=${eventId}${
          search ? `&search=${search}` : ""
        }`,
        token
      );
    } catch (error) {
      throw error;
    }
  },

  // add participant to class
  addParticipantToClass: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/participant/manual`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  // add participant to event
  addParticipantToEvent: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/event/participant/manual`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  // Event Api's
  getEventList: async (token, current_page, items_per_page, body = null) => {
    try {
      return await Service.post({
        url: `/schools/v1/event/list?current_page=${current_page}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  deleteEvent: async (token, id) => {
    try {
      return await Service.remove({ url: `/schools/v1/event?id=${id}`, token });
    } catch (error) {
      throw error;
    }
  },
  archiveEvent: async (token, body) => {
    try {
      return await Service.update({
        url: `/schools/v1/event/archive`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  duplicateEvent: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/event/duplicate`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  getArchivedEvents: async (
    token,
    current_page,
    items_per_page,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `/schools/v1/event/archive?current_page=${current_page}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  exportEvent: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/event/export`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  // Event Participant table
  getEventParticipants: async (
    token,
    current_page,
    items_per_page,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `/schools/v1/event/participant/list?current_page=${current_page}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  getEventParticipantsByAccount: async ({
    token,
    payload = {},
    page = 1,
    limit = 10,
  }) => {
    try {
      return await Service.post({
        url: `/schools/v1/event/participant/account?current_page=${page}&items_per_page=${limit}`,
        token,
        data: payload,
      });
    } catch (error) {
      throw error;
    }
  },
  getEventParticipantById: async (token, id) => {
    try {
      return await Service.get(`/schools/v1/event/participant?id=${id}`, token);
    } catch (error) {
      throw error;
    }
  },
  updateEventParticipant: async (token, body, id) => {
    try {
      return await Service.update({
        url: `/schools/v1/event/participant?id=${id}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  deleteEventParticipantById: async (token, id) => {
    try {
      return await Service.remove({
        url: `/schools/v1/event/participant?id=${id}`,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  exportParticipant: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/event/participant/export`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  // Send Multiple participant payment link
  sendEventParticipantPaymentEvent: async (token, data) => {
    try {
      return await Service.post({
        url: `/schools/v1/event/participant/payment-link`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  // Send Multiple Form participant payment link
  sendFormParticipantPayment: async (token, data) => {
    try {
      return await Service.post({
        url: `/schools/v1/online-form/participant/payment-link`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  // Form
  // Create Form
  createNewForm: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/online-form`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  // GET Form BY ID
  getFormById: async (token, id) => {
    try {
      return await Service.get(`/schools/v1/online-form?id=${id}`, token);
    } catch (error) {
      throw error;
    }
  },
  // Update Form
  updateForm: async (token, body, id) => {
    try {
      return await Service.update({
        url: `/schools/v1/online-form?id=${id}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  // GET ACTIVE FORM LIST
  getFormList: async (token, current_page, items_per_page, body = null) => {
    try {
      return await Service.post({
        url: `/schools/v1/online-form/list?current_page=${current_page}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  // GET ARCHIVED FORM LIST
  getArchivedForms: async (
    token,
    current_page,
    items_per_page,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `/schools/v1/online-form/archive?current_page=${current_page}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  // DUPLICATE FORM
  duplicateForm: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/online-form/duplicate`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  // ARCHIVE FORM
  archiveForm: async (token, body) => {
    try {
      return await Service.update({
        url: `/schools/v1/online-form/archive`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  // DELETE FORM
  deleteForm: async (token, id) => {
    try {
      return await Service.remove({
        url: `/schools/v1/online-form?id=${id}`,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  // EXPORT FORM
  exportForm: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/online-form/export`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  // Form Participant table
  getFormParticipants: async (
    token,
    current_page,
    items_per_page,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `/schools/v1/online-form/participant/list?current_page=${current_page}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  // Send event participant letter
  sendEventParticipantLetter: async (token, data) => {
    try {
      return await Service.post({
        url: `/schools/v1/event/participant/letter`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  deleteFormParticipantById: async (token, id) => {
    try {
      return await Service.remove({
        url: `/schools/v1/online-form/participant?id=${id}`,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  // export participant
  exportFormParticipant: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/online-form/participant/export`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  // Send Form participant letter
  sendFormParticipantLetter: async (token, data) => {
    try {
      return await Service.post({
        url: `/schools/v1/online-form/participant/letter`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  getFormParticipantById: async (token, id) => {
    try {
      return await Service.get(
        `/schools/v1/online-form/participant?id=${id}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },

  updateFormParticipant: async (token, body, id) => {
    try {
      return await Service.update({
        url: `/schools/v1/online-form/participant?id=${id}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  // Get Class Participants by account
  getClassParticipantsByAccounts: async ({
    token,
    payload = {},
    page = 1,
    limit = 10,
  }) => {
    try {
      return await Service.post({
        url: `/schools/v1/participant/account?current_page=${page}&items_per_page=${limit}`,
        token,
        data: payload,
      });
    } catch (error) {
      throw error;
    }
  },
  duplicateTemplateForm: async ({ token, payload }) => {
    try {
      return await Service.post({
        url: `/schools/v1/form/duplicate`,
        token,
        data: payload,
      });
    } catch (error) {
      throw error;
    }
  },

  // CREATE BULK CLASS
  createBulkClass: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/class/bulk`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  // GET BULK CLASS LIST
  getBulkClassesList: async (
    token,
    current_page,
    items_per_page,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `/schools/v1/class/bulk/list?current_page=${current_page}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  // GET BULK CLASS BY ID
  getBulkClassById: async (token, id) => {
    try {
      return await Service.get(`/schools/v1/class/bulk?id=${id}`, token);
    } catch (error) {
      throw error;
    }
  },

  // UPDATE BULK CLASS
  updateBulkClass: async (token, body) => {
    try {
      return await Service.update({
        url: `/schools/v1/class/bulk`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  // DUPLICATE BULK CLASS
  duplicateBulkClass: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/class/bulk/duplicate`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  // ARCHIVE BULK CLASS
  archiveBulkClass: async (token, body) => {
    try {
      return await Service.update({
        url: `/schools/v1/class/bulk/archive`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  // DELETE BULK CLASS
  deleteBulkClass: async (token, id) => {
    try {
      return await Service.remove({
        url: `/schools/v1/class/bulk?id=${id}`,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  createMemberForm: async (body, token) => {
    try {
      return await Service.post({
        url: `/schools/v1/membership-form`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  getMemberForms: async (token, current_page, items_per_page, body = null) => {
    try {
      return await Service.post({
        url: `/schools/v1/membership-form/list?current_page=${current_page}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  deleteMemberForm: async (token, id) => {
    try {
      return await Service.remove({
        url: `/schools/v1/membership-form?id=${id}`,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  exportMemberForm: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/membership-form/export`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  duplicateMemberForm: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/membership-form/duplicate`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  archiveMemberForm: async (token, body) => {
    try {
      return await Service.update({
        url: `/schools/v1/membership-form/archive`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  getMemberById: async (token, formId) => {
    try {
      return await Service.get(
        `/schools/v1/membership-form?id=${formId}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },
  updateMember: async (token, body, formId) => {
    try {
      return await Service.update({
        url: `/schools/v1/membership-form?id=${formId}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  createInvitation: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/membership-form/send-invitation`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  getMemberShipForm: async (token, id) => {
    try {
      return await Service.get(`/schools/v1/membership-form?id=${id}`, token);
    } catch (error) {
      throw error;
    }
  },
  getFormMembers: async (token, body = null) => {
    try {
      return await Service.post({
        url: `/schools/v1/membership-form/participant/list`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  getFormMemberById: async (token, id) => {
    try {
      return await Service.get(
        `/schools/v1/membership-form/participant?id=${id}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },
  deleteFormMemberById: async (token, id) => {
    try {
      return await Service.remove({
        url: `/schools/v1/membership-form/participant?id=${id}`,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  resendFormInvitation: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/membership-form/participant/resend-invitation`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  exportForMember: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/membership-form/participant/export`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  markAttendee: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/event/participant/attendee`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
};

export default PreSchoolService;
